module.exports = __webpack_public_path__ + "img/obras7.5e44f0ce.svg";